<section class="shiksha-sales-funnel" [attr.aria-label]="content.ariaLabel">
    <header class="shiksha-sales-funnel__header">
        <div class="shiksha-sales-funnel__header-top">
            <div>
                <app-shiksha-dashboard-subtitle-header
                    [title]="content.title"
                    [subtitle]="content.subtitle"
                    [showInfo]="false"
                    [iconName]="uiConfig.titleIconName"
                    [iconSize]="uiConfig.titleIconSize"
                />
            </div>
            <div
                class="shiksha-sales-funnel__view-toggle shiksha-sales-funnel__view-toggle--hidden"
                role="group"
                [attr.aria-label]="content.viewModeAriaLabel"
                aria-hidden="true"
            >
                <button
                    class="shiksha-sales-funnel__toggle-btn"
                    [class.shiksha-sales-funnel__toggle-btn--active]="viewMode() === 'funnel'"
                    (click)="viewMode.set('funnel')"
                    [attr.aria-label]="content.funnelViewLabel"
                    [attr.aria-pressed]="viewMode() === 'funnel'"
                    type="button"
                    tabindex="-1"
                >
                    <img [src]="content.funnelViewIconPath" alt="" aria-hidden="true" />
                </button>
                <button
                    class="shiksha-sales-funnel__toggle-btn"
                    [class.shiksha-sales-funnel__toggle-btn--active]="viewMode() === 'table'"
                    (click)="viewMode.set('table')"
                    [attr.aria-label]="content.tableViewLabel"
                    [attr.aria-pressed]="viewMode() === 'table'"
                    type="button"
                    tabindex="-1"
                >
                    <img [src]="content.tableViewIconPath" alt="" aria-hidden="true" />
                </button>
            </div>
        </div>
    </header>

    @if (viewMode() === 'funnel') {
        <div class="shiksha-sales-funnel__rows">
            @for (stage of viewStages(); track stage.stageCode) {
                <article class="shiksha-sales-funnel__row">
                    <div class="shiksha-sales-funnel__meta-row">
                        <span class="shiksha-sales-funnel__stage">
                            {{ stage.stageCode }} - {{ stage.stageLabel }}
                        </span>
                        <span class="shiksha-sales-funnel__count">{{
                            stage.totalEnteredCount
                        }}</span>
                        @if (stage.dealWonValueDisplay) {
                            <span
                                class="shiksha-sales-funnel__deal-won-value"
                                [class.shiksha-sales-funnel__deal-won-value--won]="
                                    stage.stageCode === 'S4' || stage.stageCode === 'S5'
                                "
                            >
                                {{ stage.dealWonValueDisplay }}
                            </span>
                        } @else {
                            <span
                                class="shiksha-sales-funnel__amount-slot"
                                aria-hidden="true"
                            ></span>
                        }
                    </div>

                    <div class="shiksha-sales-funnel__track" aria-hidden="true">
                        <span class="shiksha-sales-funnel__track-rail">
                            <span
                                class="shiksha-sales-funnel__fill"
                                [class.shiksha-sales-funnel__fill--s5]="stage.stageCode === 'S5'"
                                [style.width.%]="stage.progressPercent"
                            ></span>
                        </span>
                    </div>

                    <div
                        class="shiksha-sales-funnel__conversion-slot"
                        [class.shiksha-sales-funnel__conversion-slot--s0]="stage.stageCode === 'S0'"
                    >
                        @if (stage.stageCode !== 'S0' && stage.stageCode !== 'S5') {
                            <p class="shiksha-sales-funnel__conversion">
                                <span class="shiksha-sales-funnel__conversion-arrow">→</span>
                                <span class="shiksha-sales-funnel__conversion-value">{{
                                    stage.conversion
                                }}</span>
                                <span
                                    class="shiksha-sales-funnel__conversion-info"
                                    [attr.aria-label]="getConversionInfoLabel(stage.stageCode)"
                                    tabindex="0"
                                >
                                    <app-svg-icon name="info" size="xs" aria-hidden="true" />
                                    <span class="shiksha-sales-funnel__conversion-tooltip">
                                        {{ getConversionInfoLabel(stage.stageCode) }}
                                    </span>
                                </span>
                            </p>
                        }
                    </div>
                </article>
            }
        </div>
    }

    @if (viewMode() === 'table') {
        <div class="shiksha-sales-funnel__data-table">
            <div class="shiksha-sales-funnel__data-head">
                <span
                    class="shiksha-sales-funnel__data-head-stage"
                    [attr.aria-label]="
                        content.tableStageHeaderFrom +
                        content.tableStageAriaJoiner +
                        content.tableStageHeaderTo
                    "
                >
                    <span>{{ content.tableStageHeaderFrom }}</span>
                    <app-svg-icon
                        class="shiksha-sales-funnel__data-stage-arrow"
                        name="arrow-right"
                        size="sm"
                        aria-hidden="true"
                    />
                    <span>{{ content.tableStageHeaderTo }}</span>
                </span>
                <span>{{ content.tableConvHeader }}</span>
                <span>{{ content.tableDealsHeader }}</span>
            </div>
            <div class="shiksha-sales-funnel__data-rows">
                @for (transition of tableTransitions(); track transition.id) {
                    <div class="shiksha-sales-funnel__data-row">
                        <span
                            class="shiksha-sales-funnel__data-stage"
                            [attr.aria-label]="
                                transition.fromCode +
                                content.tableStageAriaJoiner +
                                transition.toCode
                            "
                        >
                            <span class="shiksha-sales-funnel__data-stage-code">{{
                                transition.fromCode
                            }}</span>
                            <app-svg-icon
                                class="shiksha-sales-funnel__data-stage-arrow"
                                name="arrow-right"
                                size="sm"
                                aria-hidden="true"
                            />
                            <span class="shiksha-sales-funnel__data-stage-code">{{
                                transition.toCode
                            }}</span>
                        </span>
                        <span class="shiksha-sales-funnel__data-conv">
                            <span class="shiksha-sales-funnel__data-conv-label">
                                <span class="shiksha-sales-funnel__data-conv-value">
                                    {{ transition.conversionLabel }}
                                </span>
                                <span class="shiksha-sales-funnel__data-conv-caption">{{
                                    content.tableConversionCaption
                                }}</span>
                            </span>
                            <span class="shiksha-sales-funnel__data-conv-bar-track">
                                <span
                                    class="shiksha-sales-funnel__data-conv-bar-fill"
                                    [style.width.%]="transition.conversionPercent"
                                ></span>
                            </span>
                        </span>
                        <span class="shiksha-sales-funnel__data-cell">
                            {{ transition.dealsLabel }}
                        </span>
                    </div>
                }
            </div>
        </div>
    }
</section>
